import clsx from "clsx";
import { Container } from "react-bootstrap";

interface Props {
  className?: string;
}

export default function Footer(props: Props) {
  return (
    <footer className={clsx("border-top py-1", props.className)}>
      <Container>
        <small className="text-muted">
          &copy; {new Date().getFullYear()} Briefpoint{" "}
        </small>
      </Container>
    </footer>
  );
}
